export class ProofOfDeliveryBean {
  referenceKey: string;
  podFile: string;
  fileName: string;

  constructor() {
    this.referenceKey = '';
    this.podFile = '';
    this.fileName = '';
  }

}
